/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect, useState } from 'react'
import {
    HeartIcon,
    BookmarkIcon,
    ShareIcon,
    ChatBubbleBottomCenterIcon
} from "@heroicons/react/24/solid";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCoverflow, Pagination } from 'swiper/modules';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

// @store
import usePostStore from '../../store/usePostStore';
import { useSpinnerStore } from '../../store/useSpinnerStore';

// @types
import { Post } from '../../types/post.types';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// @services
import profileService from "../../services/profile.service";

const Marketplace = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
    const [marketplaceList, setMarketplaceList] = useState<Post[]>([]);
    const { t } = useTranslation();
    const { openSpinner } = useSpinnerStore();
    const { getAllPosts } = usePostStore();
    const [galleryReels, setGalleryReels] = useState<{ id: string, value: Blob }[]>([]);

    // change endpoint later
    const getListPosts = async () => {
        openSpinner(true);
        try {
            const response = await getAllPosts();
            if (response?.items.length) response?.items?.map((item: Post) => getLogoByPost(item?.postId))
            setMarketplaceList(response?.items);
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.callList"));
        }
    }

    const getLogoByPost = async (postId: string) => {
        if (!postId) return;
        openSpinner(true);
        try {
            await profileService.getLogoByPost(postId ?? '').then((response: any) => {
                const list = galleryReels;
                list.push({ id: postId, value: response });
                return setGalleryReels(list);
            })
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.callList"));
        }
    }

    useEffect(() => {
        getListPosts();
    }, [])

    const getImage = (post: string) => {
        const image = galleryReels?.find((item: any) => item?.id === post);
        if (!image) return "";
        const renderImage = URL.createObjectURL(image.value);
        return renderImage;
    }

    return (
        <section className='lg:w-[60%] w-full mx-auto flex justify-center p-2'>
            {marketplaceList?.length
                ? <div className='w-full'>
                    <Swiper
                        spaceBetween={"10px"}
                        slidesPerView={isMobile ? 1 : 2}
                        navigation={true}
                        pagination={true}
                        modules={[EffectCoverflow, Pagination, Navigation]}
                        effect={'coverflow'}
                        grabCursor={true}
                        centeredSlides={true}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: false,
                        }}
                    >
                        {marketplaceList.map((reel: Post) => (
                            <SwiperSlide>
                                <div className="flex items-center p-4 h-[80vh]">
                                    <div className="w-[300px] h-[500px] mx-auto flex gap-2">
                                        <div className="relative w-full h-full p-2">
                                            <>
                                                {galleryReels?.length
                                                    ? <img
                                                        src={getImage(reel?.postId)}
                                                        alt="Preview"
                                                        onError={(e: any) => (e.target.src = '/assets/img/no-image.png')}
                                                        className="w-full h-full object-cover rounded-xl"
                                                    />
                                                    : <img
                                                        src={'/assets/img/no-image.png'}
                                                        alt={"Deefault background"}
                                                        className="rounded-xl cover h-full w-full"
                                                    />
                                                }

                                                {/* Interaction buttons column */}
                                                <div className="absolute bottom-10 left-4 flex items-end gap-4">
                                                    <div className="p-4">
                                                        <h4 className="text-white font-semibold">{reel.title}</h4>
                                                        <p className="text-white text-sm mt-1">{reel.description}</p>
                                                        <p className="text-white/80 text-sm mt-2 font-medium">
                                                            {reel.hashtags}
                                                        </p>

                                                    </div>
                                                </div>
                                            </>
                                        </div>

                                        <div className='flex flex-col items-end justify-end gap-4'>
                                            <div className="flex flex-col items-center">
                                                <button className="bg-[#F1F1F2] rounded-[100%] p-[5px]">
                                                    <HeartIcon className="h-7 w-7 text-[#50525A]" />
                                                </button>
                                                <span className="text-[#50525A] font-bold text-xs">0</span>
                                            </div>
                                            <div className="flex flex-col items-center">
                                                <button className="bg-[#F1F1F2] rounded-[100%] p-[5px]">
                                                    <ChatBubbleBottomCenterIcon className="h-7 w-7 text-[#50525A]" />
                                                </button>
                                                <span className="text-[#50525A] font-bold text-xs">0</span>
                                            </div>
                                            <div className="flex flex-col items-center">
                                                <button className="bg-[#F1F1F2] rounded-[100%] p-[5px]">
                                                    <BookmarkIcon className="h-7 w-7 text-[#50525A]" />
                                                </button>
                                                <span className="text-[#50525A] font-bold text-xs">0</span>
                                            </div>
                                            <div className="flex flex-col items-center">
                                                <button className="bg-[#F1F1F2] rounded-[100%] p-[5px]">
                                                    <ShareIcon className="h-7 w-7 text-[#50525A]" />
                                                </button>
                                                <span className="text-[#50525A] font-bold text-xs">0</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                : <p className='w-full h-[70vh] flex text-[25px] text-gray-400 dark:text-white items-center justify-center'>
                    {t("marketplace.noReels")}
                </p>
            }
        </section>
    )
}

export default Marketplace